import { all, takeLatest, put } from 'redux-saga/effects';
import { GET_USERS, INVITE_USER, UPDATE_USER, DELETE_USER } from './constants';
import {
    requestUsers,
    requestInviteUser,
    requestUpdateUser,
    requestDeleteUser
} from './api';
import {
    getUsersSuccess,
    inviteUserSuccess,
    inviteUserFailure,
    updateUserSuccess,
    updateUserFailure,
    deleteUserSuccess,
} from './actions';

/**
 *
 * @returns {IterableIterator<PutEffect<{users: *, type: string}>>}
 */
function* getUsers() {
    const users = yield requestUsers();
    if (users) {
        yield put(getUsersSuccess(users));
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{response, type}>>}
 */
function* inviteUser(actionObj) {
    const { resolve, reject } = actionObj;
    try {
        const response = yield requestInviteUser(actionObj.formData);
        if (response.success) {
            yield put(inviteUserSuccess(response));
            resolve(response);
        } else {
            if (response.errors) {
                yield put(inviteUserFailure(response.errors));
                reject(response.errors);
            }
        }
    } catch (error) {
        console.error('Invite User Error:', error);
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{user, type}>>}
 */
function* updateUser(actionObj) {
    const { resolve, reject } = actionObj;

    try {
        const response = yield requestUpdateUser(actionObj.formData);
        if (response.success) {
            yield put(updateUserSuccess(response.users));
            resolve(response);
        } else {
            if (response.errors) {
                yield put(updateUserFailure(response.errors));
                reject(response.errors);
            }
        }
    } catch (error) {
        console.log("error " + error);
        // if (error.response && error.response.status === 422) {
        //     yield put(updateUserFailure(error.response.data.errors));
        //     reject(error.response.data.errors);
        // } else {
        //     // Handle other errors
        //     const unexpectedError = { unexpected: 'An unexpected error occurred.' };
        //     yield put(updateUserFailure(unexpectedError));
        //     reject(unexpectedError);
        // }
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{users, type}>>}
 */
function* deleteUser(actionObj) {
    const users = yield requestDeleteUser(actionObj.id);
    if (users) {
        yield put(deleteUserSuccess(users));
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchUsers() {
    yield takeLatest(GET_USERS, getUsers);
    yield takeLatest(INVITE_USER, inviteUser);
    yield takeLatest(UPDATE_USER, updateUser);
    yield takeLatest(DELETE_USER, deleteUser);
}

function* usersSaga() {
    yield all([
        watchUsers()
    ]);
}

export default usersSaga;